<template>
  <div class="over-view-main-top">
    <div class="over-view-main-top-line" v-for="line in topData">
      <div class="over-view-main-top-item" v-for="item in line" :style="{background: item.background}">
        <img :src="item.icon" alt="" class="over-view-main-top-item-img">
        <div class="over-view-main-top-item-info" :style="{color: item.color}">
          <div class="over-view-main-top-item-info-name">{{item.name}}<span class="over-view-main-top-item-info-unit">({{item.unit}})</span></div>
          <div class="over-view-main-top-item-info-num" >{{item.value}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "OverViewTopLine",
  props: {
    topData: {
      type: Array,
      default () {
        return []
      }
    }
  }
}
</script>

<style scoped lang="less">
.over-view-main-top {
  width: 100%;
  .over-view-main-top-line {
    width: 100%;
    margin-top: 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .over-view-main-top-item {
      flex: 1;
      width: 177px;
      padding: 0 13px;
      height: 87px;
      margin: 10px 18px 10px 0;
      border-radius: 5px;
      box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
      display: flex;
      justify-content: space-between;
      align-items: center;
      .over-view-main-top-item-img {
        width: 48px;
        height: 48px;
        margin-right: 10px;
      }
      .el-icon-damai-xitongguanli-zhuceqiye {
        font-size: 48px;
      }
      .over-view-main-top-item-info {
        flex: 1;
        text-align: left;
        .over-view-main-top-item-info-name {
          height: 22px;
          font-size: 15px;
          font-family: Source Han Sans SC;
          font-weight: 400;
          line-height: 22px;
          text-align: center;
          .over-view-main-top-item-info-unit {}
        }
        .over-view-main-top-item-info-num {
          word-wrap:break-word;
          height: 43px;
          text-align: center;
          font-size: 33px;
          font-family: DINPro;
          font-weight: bold;
          line-height: 43px;
          opacity: 1;
        }
      }
    }

    .over-view-main-top-item:last-child {
      margin: 10px 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/OverView/OverViewTopLine.vue